import {
   seats_resp_groups_query,
   getSeatsByUserId,
   resp_groups_multi_modify,
   rel_exts_users_query,
   switch_bind_seat,
   universal_cfg_create, // 添加这两个 API 引用
   universal_cfg_query,
   describe_number
} from '@/views/individualCenter/api'
import Vue from 'vue'
import { Toast } from 'vant'
import util from '@/libs/util.js'
import i18n from '@/i18n'

Vue.use(Toast)
export default {
   namespaced: true,
   state: {
      // 语言
      language: '',

      //直呼0 or 双呼1
      callingMode: '',

      //h5拨打0 or 小程序拨打1
      dialingMethod: '',

      //默认坐席
      defaultSeat: {},

      //坐席列表
      seatList: [],

      //用户分机信息
      relExtsUsers: {},
      
      //外呼号码列表
      callOutNumbers: [],
      
      //默认值班座席（用于 dutyPhone 页面）
      defaultDutySeat: null,
   },
   actions: {
      /**
       * @description 获取用户坐席列表
       * @param {Object} context
       * @param {Object} payload jcon_um_users__user_ids {String} 用户userid
       */
      async getTheUserSeatList(
         { state, dispatch },
         user_ids = []
      ) {
         // 兼容数组和单个 user_id
         const user_id = Array.isArray(user_ids) ? user_ids[0] : user_ids
         
         if (!user_id) {
            state.defaultSeat = {}
            state.seatList = []
            state.defaultDutySeat = null
            return
         }

         let data = {
            data: {
               user_id: user_id
            }
         }
         
         let res = await getSeatsByUserId(data)
         if (
            res &&
            res.status_code == 0 &&
            res.data &&
            res.data.seats &&
            res.data.seats.length
         ) {
            // 处理坐席列表
            const seats = res.data.seats
            for (let i = 0; i < seats.length; i++) {
               seats[i].line = i + 1
            }
            
            // 设置坐席列表
            state.seatList = seats

            // 设置默认坐席（优先找 is_default_seat 为 true 且 seat_type 为 NORMAL 的座席）
            // 如果找不到，fallback 到取第一个 NORMAL 类型的座席（向后兼容）
            const defaultSeat = seats.find(s => s.seat_type === 'NORMAL' && s.is_default_seat === true)
            const fallbackSeat = seats.find(s => s.seat_type === 'NORMAL')
            if (defaultSeat) {
               state.defaultSeat = { ...defaultSeat }
            } else if (fallbackSeat) {
               state.defaultSeat = { ...fallbackSeat }
            } else {
               state.defaultSeat = {}
            }
            
            // 存储默认值班座席（用于 dutyPhone 页面）
            state.defaultDutySeat = res.data.default_duty_seat || null
         } else {
            state.defaultSeat = {}
            state.seatList = []
            state.defaultDutySeat = null
         }
      },

      /**
       * @description 查询分机or手机接听
       * @param {Object} context
       * @param {Object} payload jcon_um_users__user_ids {String} 用户userid
       */
      async relExtsUsersQuery({ state, dispatch }, um_users__user_ids = []) {
         let data = {
            ad_uid: '',
            client_id: '',
            data: {
               page: {
                  page_size: 100,
                  page_index: 0,
               },
               filters: {
                  'jcon_tccc_resp_groups.um_users__user_ids':
                     um_users__user_ids,
               },
               orders: {
                  update_time: 'desc',
               },
            },
         }
         let res = await rel_exts_users_query(data)
         if (
            res &&
            res.status_code == 0 &&
            res.data &&
            res.data.list &&
            res.data.list[0]
         ) {
            state.relExtsUsers = res.data.list[0]
         } else {
            state.relExtsUsers = {}
         }
      },

      /**
       * @description 切换分机or手机接听
       * @param {Object} context
       * @param {Object} payload jcon_um_users__user_ids {String} 用户userid
       */
      async switchBindSeat(
         { state, dispatch },
         { extension_id = '', update_userid = '', switch_status = '' }
      ) {
         let data = {
            ad_uid: '',
            client_id: '',
            switch_status: switch_status,
            data: {
               extension_id: extension_id,
               update_userid: update_userid,
            },
         }
         let res = await switch_bind_seat(data)
         if (
            res &&
            res.status_code == 0 &&
            res.data &&
            res.data.save_local &&
            res.data.save_local.status_code == 0
         ) {
         } else {
            Toast.fail('切换失败')
         }
      },

      /**
       * @description 设置用户默认列表
       * @param {Object} context
       * @param {Object} payload jcon_um_users__user_ids {String} 用户userid
       * @param {Object} payload tccc_seats__default_mail {String} 坐席邮箱
       */
      async respGroupsMultiModify(
         { state, dispatch },
         { jcon_um_users__user_ids = [], tccc_seats__default_mail = '' }
      ) {
         let data = {
            ad_uid: '',
            client_id: '',
            data: {
               filters: {
                  jcon_um_users__user_ids: jcon_um_users__user_ids,
               },
               update_data: {
                  tccc_seats__default_mail: tccc_seats__default_mail,
               },
            },
         }
         let res = await resp_groups_multi_modify(data)
         if (res && res.status_code == 0 && res.data.status_code == 0) {
            // Toast.success('切换默认坐席成功')
         } else {
            Toast.fail('切换默认坐席失败')
         }
      },

      /**
       * @description 切换语言
       * @param {Object} context
       * @param {*} info info
       */
      async switchLanguage({ state, dispatch }, info) {
         util.localStorage.set('lang', info)
         i18n.locale = info

         // store 赋值
         state.language = info

         // 持久化
         await dispatch(
            'tccc/db/set',
            {
               dbName: 'sys',
               path: 'individualCenter.language',
               value: info,
               user: true,
            },
            { root: true }
         )
      },

      /**
       * @description 切换呼叫方式
       * @param {Object} context
       * @param {*} info info
       */
      async switchCallingMode({ state, dispatch }, info) {
         // store 赋值
         state.callingMode = info
         // 持久化
         await dispatch(
            'tccc/db/set',
            {
               dbName: 'sys',
               path: 'individualCenter.callingMode',
               value: info,
               user: true,
            },
            { root: true }
         )
      },

      /**
       * @description 切换拨打方式
       * @param {Object} context
       * @param {*} info info
       */
      async switchDialingMethod({ state, dispatch }, info) {
         // store 赋值
         state.dialingMethod = info
         // 持久化
         await dispatch(
            'tccc/db/set',
            {
               dbName: 'sys',
               path: 'individualCenter.dialingMethod',
               value: info,
               user: true,
            },
            { root: true }
         )
      },

      /**
       * @description 切换默认坐席
       * @param {Object} context
       * @param {*} info info
       */
      async switchDefaultSeat({ state, dispatch }, info) {
         // store 赋值
         state.defaultSeat = info
         // 持久化
         await dispatch(
            'tccc/db/set',
            {
               dbName: 'sys',
               path: 'individualCenter.defaultSeat',
               value: info,
               user: true,
            },
            { root: true }
         )
      },

      /**
       * @description 查询用户拨打方式
       */
      async universalCfgQuery({ state, dispatch }, user_id) {
         let data = {
            ad_uid: '',
            client_id: '',
            data: {
               page: {
                  page_size: 1,
                  page_index: 0,
               },
               filters: {
                  table_name: 'um_users',
                  key_field_name: 'user_id',
                  key_field_val: user_id,
               },
               orders: {
                  update_time: 'desc',
               },
            },
         }
         let res = await universal_cfg_query(data)
         console.log(res, 'res')
         if (
            res &&
            res.status_code == 0 &&
            res.data &&
            res.data.list &&
            res.data.list.length
         ) {
            // 如果返回的数据中有 dialing_method，更新状态
            if (
               res.data.list[0].config_content.tccc_launch_agent !== undefined
            ) {
               dispatch(
                  'switchDialingMethod',
                  res.data.list[0].config_content.tccc_launch_agent
               )
            }
         }
         return res
      },

      /**
       * @description 切换用户拨打方式
       */
      async universalCfgCreate({ state, dispatch }, data) {
         console.log(data, 'data')
         let params = {
            ad_uid: '',
            client_id: '',
            data: {
               table_name: 'um_users',
               key_field_name: 'user_id',
               key_field_val: data.user_id,
               config_type: '应用配置',
               config_desc: '切换成小程序拨打或者h5拨打',
               config_content: {
                  tccc_launch_agent: data.dialingMethod, //"mini_grogram" // sip_sdk
               },
            },
         }
         // 如果有 uuid，则添加到请求参数中
         if (data.uuid) {
            params.data.uuid = data.uuid
         }

         let res = await universal_cfg_create(params)
         return res
      },

      /**
       * @description 从数据库取用户设置数据
       * @param {Object} context
       */
      async load({ state, dispatch }) {
         let language = await dispatch(
            'tccc/db/get',
            {
               dbName: 'sys',
               path: 'individualCenter.language',
               defaultValue: 'zh-CN',
               user: true,
            },
            { root: true }
         )
         let callingMode = await dispatch(
            'tccc/db/get',
            {
               dbName: 'sys',
               path: 'individualCenter.callingMode',
               defaultValue: '0',
               user: true,
            },
            { root: true }
         )
         let dialingMethod = await dispatch(
            'tccc/db/get',
            {
               dbName: 'sys',
               path: 'individualCenter.dialingMethod',
               defaultValue: 'mini_grogram',
               user: true,
            },
            { root: true }
         )
         let defaultSeat = await dispatch(
            'tccc/db/get',
            {
               dbName: 'sys',
               path: 'individualCenter.defaultSeat',
               defaultValue: {},
               user: true,
            },
            { root: true }
         )
         // store 赋值
         state.language = language
         state.callingMode = callingMode
         state.dialingMethod = dialingMethod
         state.defaultSeat = defaultSeat
      },

      /**
       * @description 获取外呼号码列表
       * @param {Object} context
       */
      async getCallOutNumbers({ state, dispatch }) {
         let data = {
            ad_uid: '',
            client_id: util.localStorage.get("client_id"),
            data: {
               page_size: 100,
               page_number: 0,
            },
         }
         let res = await describe_number(data)
         if (
            res &&
            res.status_code == 0 &&
            res.data &&
            res.data.Numbers
         ) {
            state.callOutNumbers = res.data.Numbers
            return res.data.Numbers
         } else {
            state.callOutNumbers = []
            return []
         }
      },
   },
}
